import React, { Component } from 'react';
import InputDropdownDre from './InputDropdownDre';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import { toast } from 'react-toastify';
import { withTheme } from 'styled-components';

class FiltersPageHabilidade extends Component {
  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };

  state = {
    loading: false,
    isLoading: false,
    isPlaceholder: 'Selecione',
    avaliacoes: [],
    dreOptions: [],
    escolaOptions: [],
    etapaOption: [],
    turmaOptions: [],
    disciplinaOptions: [],
    alunoOptions: [],
    cursosAtual: null,
    disciplinaAtual: null,
    integracaoPayload: null,
    currentEscola: null,
    currentStudent: null,
    disciplinaID: null,
    nrEtapa: null,
    dsiciplinaCurrent: null,
    DisciplinaID: null,
    cd_escola: null,
    cd_turma: null,
    dreIdLocal: "",
    municipioIdLocal: "",
    escoalIdLocal: "",
    etapaIdLocal: "",
    turmaIdLocal: "",
    disciplinaIdLocal: "",
    anoIdLocal: "",
    idsLocalStorage: [],
    idsLocalState: [],
  };

  mapData = (d) => ({ value: d.external_id, label: d.dre_name, id: d.external_id, ...d });
  escolaData = (d) => ({ value: d.cd_escola, label: d.nm_escola, ...d });
  etapaEscolaData = (d) => ({ value: d.nr_etapa, label: d.dc_etapa, ...d });
  turmaData = (d) => ({
    value: d.cd_turma,
    label: '(' + d.nm_turma + ') ' + d.cd_turma,
    ...d
  });
  disciplinaData = (d) => ({ value: d.id, label: d.disciplina, ...d });
  alunoData = (d) => ({ value: d.id, label: d.nm_aluno, ...d });
  municipioData = (d) => ({
    value: d.cd_municipio,
    label: d.nm_municipio,
    ...d
  });

  provaData = (d) => ({
    value: d.id,
    label: `${d.ds_prova} - ${d.id}`
  });
  anoData = (d) => ({
    value: d.id,
    label: d.ds_ano
  });
  periodoData = (d) => ({
    value: d.id,
    label: d.ds_periodo
  });
  fetchDre = () => {
    axios
      .get(`${API_HOST}/avalia/dre`)
      .then((res) => {
        const data = res.data.map(this.mapData);
        this.setState({ dreOptions: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchMunicipio = (dreId) => {
    if (dreId) {
      axios
        .get(`${API_HOST}/avalia/municipio?dre_id=${dreId.id}`)
        .then((res) => {
          const data = res.data.results.map(this.municipioData);
          this.setState({ municipioOption: data, dreIdLocal: dreId.id })
        })
        .catch((err) => {
          toast.error(err);
        });
    }
  };

  fetchEscola = (dreId) => {
    if (dreId) {
      axios
        .get(`${API_HOST}/avalia/escola?cd_municipio=${dreId.value}`)
        .then((res) => {
          const data = res.data.map(this.escolaData);
          this.setState({ escolaOptions: data, municipioIdLocal: dreId.value });
        })
        .catch((err) => {
          toast.error(err);
        });
    }
  };

  fetchEtapaEscolaNome = (e) => {
    this.setState({ currentEscola: e.value });
    axios
      .get(`${API_HOST}/avalia/escola_etapa?cd_escola=${e.value}`)
      .then((res) => {
        const data = res.data.results.map(this.etapaEscolaData);
        this.setState({ etapaOption: data, currentEscola: data[0].cd_escola });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchEtapaEscola = (cdEscola) => {
    if (cdEscola) {
      this.setState({ currentEscola: cdEscola.cd_escola });
      axios
        .get(`${API_HOST}/avalia/escola_etapa?cd_escola=${cdEscola.cd_escola}`)
        .then((res) => {
          const data = res.data.results.map(this.etapaEscolaData);
          this.setState({ etapaOption: data, escoalIdLocal: cdEscola.cd_escola });
        })
        .catch((err) => {
          toast.error(err);
        });
    }
  };

  fetchTurma = (escolaId) => {
    this.setState({ EtapaNumero: escolaId.value });
    if (escolaId) {
      this.setState({ nrEtapa: escolaId.cd_etapa });
      axios
        .get(
          `${API_HOST}/avalia/turma?cd_escola=${escolaId.cd_escola}&cd_etapa=${escolaId.cd_etapa}`
        )
        .then((res) => {
          const data = res.data.results.map(this.turmaData);
          this.setState({ turmaOptions: data, etapaIdLocal: escolaId.value });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  fetchDisciplinas = (disciplina) => {
    axios
      .get(`${API_HOST}/avalia/disciplina`)
      .then((res) => {
        const data = res.data.results.map(this.disciplinaData);
        this.setState({
          disciplinaOptions: data,
          cd_turma: disciplina.cd_turma,
          cd_escola: disciplina.cd_escola,
          turmaIdLocal: disciplina.dre_id
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchAno = () => {
    axios
      .get(`${API_HOST}/avalia/ano`)
      .then((res) => {
        const data = res.data.map(this.anoData);
        this.setState({ anoOptions: data });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchAno = () => {
    axios
      .get(`${API_HOST}/avalia/ano`)
      .then((res) => {
        const data = res.data.map(this.anoData);
        this.setState({ anoOptions: data });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  fetchPeriodo = () => {
    axios
      .get(`${API_HOST}/avalia/periodo`)
      .then((res) => {
        const data = res.data.map(this.periodoData);
        this.setState({ periodoOptions: data });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  fetchAnoPeriodo = (e, ano) => {
    axios
      .get(`${API_HOST}/avalia/periodo_ano?periodo__id=${e}&ano__id=${ano}`)
      .then((res) => {
        this.setState({ periodoAno: res.data[0].id });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchDres(me) {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/core/rede_dre_inst/${me}/get_dres`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })

      .then((response) => {
        this.setState({
          dres: response.data.dre.map((x) => ({
            id: x.cd_dre,
            value: x.ds_dre,
            label: x.ds_dre
          }))
        });
      })
      .catch((response) => toast.error(response.error));
  }
  fetchDresAdm() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/avalia/dre`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })

      .then((response) => {
        this.setState({
          dres: response.data.map((x) => ({
            id: x.external_id,
            value: x.dre_name,
            label: x.dre_name
          }))
        });
      })
      .catch((response) => toast.error(response.error));
  }
  fetchInstitution(me, dre) {
    const token = localStorage.getItem('token');
    this.setState({ isLoading: true, isPlaceholder: 'Carregando...' });

    axios
      .get(
        `${API_HOST}/core/rede_dre_inst/get_escolas?user_group_instituicao__usuario=${me}&dre__cd_dre=${dre}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      )

      .then((response) => {
        this.setState({
          isPlaceholder: 'Selecione',
          isLoading: false,
          institutions: response.data.map((x) => ({
            id: x.instituicao.instituicao.id,
            value: x.instituicao.instituicao.codigo,
            label: x.instituicao.instituicao.descricao
          }))
        });
      })
      .catch((response) => {
        toast.error(response.error);
        this.setState({ isLoading: false });
      });
  }

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
        let groups = response.data.logged_group.map(f => { return f.toUpperCase(); })
        if (groups.includes('ADMINISTRADOR')) {
          this.fetchDresAdm();
        } else {
          this.fetchDres(response.data.id);
        }
      })
      .catch((response) => toast.error(response.error));
  }

  idsLocalStorageFun() {
    var arrayIds = [];
    var localStorageGetIds = localStorage.getItem("idsFilter" || "{}");

    arrayIds = JSON.parse(localStorageGetIds);
    this.setState({ idsLocalState: arrayIds });
  }
  componentDidMount() {
    this.fetchMe();
    this.idsLocalStorageFun();
    this.fetchAno();
  }

  render() {
    const {
      institutions,
      EtapaNumero,
      DisciplinaID,
      anoOptions,
      escolaOptions,
      etapaOption,
      turmaOptions,
      disciplinaOptions,
      municipioOption,
      me,
      periodoOptions,
      currentEscola,
      dres,
      idsLocalStorage,
      dreIdLocal,
      escoalIdLocal,
      etapaIdLocal,
      municipioIdLocal,
      disciplinaIdLocal,
      anoIdLocal,
      idsLocalState,
      turmaIdLocal,
    } = this.state;


    const { history } = this.props;
    const groups = me && me.logged_group.map(f => { return f.toUpperCase(); })
    const legenda = 'Diretoria Regional de Educação (DRE)';

    if (
      (groups && groups.includes('DRE')) ||
      (groups && groups.includes('ADMINISTRADOR'))
    ) {
      return (
        <>
          <div style={{ marginTop: '5rem', background: '#fff' }}>
            <div className="container mb-4 pb-4">
              <div className="row">
                <div className="col-12">
                  <div
                    className="card"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                  >
                    <div
                      className="card-header"
                      style={{
                        marginBottom: '24px',
                        backgroundColor: '#f7f7f7',
                        borderRadius: '10px'
                      }}
                    >
                      <h1
                        style={{
                          fontFamily: 'Quicksand',
                          fontSize: '24px',
                          color: '#292929',
                          fontWeight: 'bold'
                        }}
                      >
                        Relatório Nível de Habilidades
                      </h1>
                      <span
                        style={{
                          fontSize: '14px',
                          color: '#292929',
                          fontWeight: 500,
                          fontFamily: 'Quicksand'
                        }}
                      >
                        Diagnóstico de proficiência por escola
                      </span>

                      <hr
                        style={{
                          background: '#bebebe',
                          width: '100%',
                          height: '1px',
                          borderRadius: '1px'
                        }}
                      />
                    </div>

                    <div className="card-body">
                      <Form
                        getApi={(formApi) => {
                          this.formApi = formApi;
                        }}
                      >

                        {({ formState }) => <div className="row"></div>}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          <div className="input-type-style">
                            <label
                              htmlFor="ano"
                              className="input-label-style-filter"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Ano</span>
                            </label>
                            <InputSelect
                              key={anoOptions}
                              label=""
                              col="col-md-12"
                              field="anoOptions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchPeriodo();
                                  this.setState({ ano: e.value, anoIdLocal: e.value });
                                }
                              }}
                              options={anoOptions}
                            />
                          </div>
                          <div className="input-type-style">
                            <label
                              htmlFor="Disciplina"
                              className="input-label-style-filter"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">
                                Prova
                              </span>
                            </label>
                            <InputSelect
                              key={periodoOptions}
                              label=""
                              col="col-md-12"
                              field="periodoOptions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchAnoPeriodo(
                                    e.value,
                                    this.state.ano,
                                    this.setState({
                                      periodoano: e.value,
                                      idsLocalStorage: [{
                                        dreIdLocal: dreIdLocal,
                                        municipioIdLocal: municipioIdLocal,
                                        escoalIdLocal: escoalIdLocal,
                                        etapaIdLocal: etapaIdLocal,
                                        turmaIdLocal: turmaIdLocal,
                                        disciplinaIdLocal: disciplinaIdLocal,
                                        anoIdLocal: anoIdLocal,
                                        tipoProvaLocal: e.value
                                      }]
                                    })
                                  );
                                }
                              }}
                              options={periodoOptions}
                            />
                          </div>
                          <div className="input-type-style">
                            <label
                              htmlFor={legenda}
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">
                                {legenda}
                              </span>
                            </label>
                            <InputSelect
                              key={dres}
                              label=""
                              col="col-md-12"
                              field="dres"
                              onChange={this.fetchMunicipio}
                              options={dres}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Departamento Regional de Educação (DR)"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Município</span>
                            </label>
                            <InputSelect
                              key={municipioOption}
                              label=""
                              col="col-md-12"
                              field="municipioOption"
                              onChange={this.fetchEscola}
                              options={municipioOption}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Escola"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Escola</span>
                            </label>
                            <InputSelect
                              isLoading={this.state.isLoading}
                              key={escolaOptions}
                              label=""
                              col="col-md-12"
                              field="escolaOptions"
                              onChange={this.fetchEtapaEscola}
                              options={escolaOptions}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Série/Ano Escolar"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">
                                Série/Ano Escolar
                              </span>
                            </label>
                            <InputSelect
                              key={etapaOption}
                              label=""
                              col="col-md-12"
                              field="etapaOption"
                              onChange={this.fetchTurma}
                              options={etapaOption}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Turma"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Turma</span>
                            </label>
                            <InputSelect
                              key={turmaOptions}
                              label=""
                              col="col-md-12"
                              field="turmaOptions"
                              onChange={this.fetchDisciplinas}
                              options={turmaOptions}
                            />
                          </div>
                          <div className="input-type-style">
                            <label
                              htmlFor="Disciplina"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Componente Curricular/Área do Conhecimento</span>
                            </label>
                            <InputSelect
                              key={disciplinaOptions}
                              label=""
                              col="col-md-12"
                              field="disciplinaOptions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchAno();
                                  this.setState({ DisciplinaID: e.value, disciplinaIdLocal: e.value });
                                }
                              }}
                              options={disciplinaOptions}
                            />
                          </div>

                          <div
                            className="input-type-style"
                            style={{
                              display: 'flex',
                              justifyContent: 'center'
                            }}
                          >
                            <button
                              style={{
                                color: 'white',
                                backgroundColor: this.props.theme.primary,
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderRadius: '15px',
                                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                letterSpacing: '1px',
                                padding: '4px 16px',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}
                              onClick={() => {
                                this.state.periodoAno
                                  ? history.push(
                                     `/relatorio-nivel-habilidade/${DisciplinaID}/escola/${currentEscola}/etapa/${EtapaNumero}/periodo/${this.state.periodoano}/ano/${anoIdLocal}`
                                  )
                                  : toast.error(
                                    'Os campos não foram preenchidos corretamente. Por favor selecione alguma opção.'
                                  );
                                localStorage.setItem("idsFilter", JSON.stringify(idsLocalStorage));
                              }}
                            >
                              Buscar
                            </button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div style={{ marginTop: '5rem', background: '#fff' }}>
            <div className="container mb-4 pb-4">
              <div className="row">
                <div className="col-12">
                  <div
                    className="card"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                  >
                    <div
                      className="card-header"
                      style={{
                        marginBottom: '24px',
                        backgroundColor: '#f7f7f7',
                        borderRadius: '10px'
                      }}
                    >
                      <h1
                        style={{
                          fontFamily: 'Quicksand',
                          fontSize: '24px',
                          color: '#292929',
                          fontWeight: 'bold'
                        }}
                      >
                        Relatório Nível de Habilidades
                      </h1>
                      <span
                        style={{
                          fontSize: '14px',
                          color: '#292929',
                          fontWeight: 500,
                          fontFamily: 'Quicksand'
                        }}
                      >
                        Diagnóstico de proficiência por escola
                      </span>
                      <hr
                        style={{
                          background: '#bebebe',
                          width: '100%',
                          height: '1px',
                          borderRadius: '1px'
                        }}
                      />
                    </div>
                    <div className="card-body">
                      <Form
                        getApi={(formApi) => {
                          this.formApi = formApi;
                        }}
                      >
                        {({ formState }) => <div className="row"></div>}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          {/* <div className="row"> */}
                          <div className="input-type-style">
                            <label
                              htmlFor={legenda}
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">
                                {legenda}
                              </span>
                            </label>
                            <InputSelect
                              label=""
                              col="col-md-12"
                              field="dres"
                              onChange={(e) => {
                                this.fetchInstitution(me.id, e.id);
                              }}
                              options={dres}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Escola"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Escola</span>
                            </label>
                            <InputSelect
                              placeholder={this.state.isPlaceholder}
                              disabled={this.state.isLoading}
                              isLoading={this.state.isLoading}
                              label=""
                              col="col-md-12"
                              field="institutions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchEtapaEscolaNome(e);
                                }
                              }}
                              options={institutions}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Série/Ano Escolar"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">
                                Série/Ano Escolar
                              </span>
                            </label>
                            <InputSelect
                              label=""
                              col="col-md-12"
                              field="etapaOption"
                              onChange={this.fetchTurma}
                              options={etapaOption}
                            />
                          </div>

                          <div className="input-type-style">
                            <label
                              htmlFor="Turma"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Turma</span>
                            </label>
                            <InputSelect
                              label=""
                              col="col-md-12"
                              field="turmaOptions"
                              onChange={this.fetchDisciplinas}
                              options={turmaOptions}
                            />
                          </div>
                          <div className="input-type-style">
                            <label
                              htmlFor="Disciplina"
                              className="input-label-style"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Componente Curricular/Área do Conhecimento</span>
                            </label>
                            <InputSelect
                              label=""
                              col="col-md-12"
                              field="disciplinaOptions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchAno();
                                  this.setState({ DisciplinaID: e.value });
                                  localStorage.setItem("disciplinaId", e.value);
                                }
                              }}
                              options={disciplinaOptions}
                            />
                          </div>
                          <div className="input-type-style">
                            <label
                              htmlFor="ano"
                              className="input-label-style-filter"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">Ano</span>
                            </label>
                            <InputSelect
                              label=""
                              col="col-md-12"
                              field="anoOptions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchPeriodo();
                                  this.setState({ ano: e.value });
                                  localStorage.setItem("anoId", e.ivalue);
                                }
                              }}
                              options={anoOptions}
                            />
                          </div>
                          <div className="input-type-style">
                            <label
                              htmlFor="Disciplina"
                              className="input-label-style-filter"
                              style={{ marginBottom: '1rem' }}
                            >
                              <span className="filter-label">
                                Prova
                              </span>
                            </label>
                            <InputSelect
                              label=""
                              col="col-md-12"
                              field="periodoOptions"
                              onChange={(e) => {
                                if (e) {
                                  this.fetchAnoPeriodo(
                                    e.value,
                                    this.state.ano,
                                    this.setState({ periodoano: e.value })
                                  );
                                  localStorage.setItem("tipoProvaId", e.value);
                                }
                              }}
                              options={periodoOptions}
                            />
                          </div>
                          <div
                            className="input-type-style"
                            style={{
                              display: 'flex',
                              justifyContent: 'center'
                            }}
                          >
                            <button
                              style={{
                                color: 'white',
                                backgroundColor: this.props.theme.primary,
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderRadius: '15px',
                                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                letterSpacing: '1px',
                                padding: '4px 16px',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}
                              onClick={() => {
                                this.state.periodoAno
                                  ? history.push(
                                     `/relatorio-nivel-habilidade/${DisciplinaID}/escola/${currentEscola}/etapa/${EtapaNumero}/periodo/${this.state.periodoano}/ano/${anoIdLocal}`
                                  )
                                  : toast.error(
                                    'Os campos não foram preenchidos corretamente. Por favor selecione alguma opção.'
                                  );
                              }}
                            >
                              Buscar
                            </button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

export default withTheme(FiltersPageHabilidade);
